import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomLink from 'components/Common/CustomLink/CustomLink';
import { default as EditIcon } from 'components/Common/Icons/Edit';

import styles from './CartProductEdit.module.scss';

export default function CartProductEdit({ url }: { url: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <CustomLink className={styles.link} to={url}>
      <EditIcon className={styles.editIcon} />
      {t('LABEL_EDIT')}
    </CustomLink>
  );
}
